import React, { ReactNode } from "react";
import { createPortal } from "react-dom";

interface Props {
    L: any
    map: any
    position: string
    className: string
    children?: ReactNode
}

export default function Control({ L, map, position, className, children }: Props) {

    const controlDiv = L.DomUtil.create('div', className);

    L.Control.MyControl = L.Control.extend({
        options: { position },
        onAdd: (map: any) => controlDiv,
        onRemove: (map: any) => {},
    });

    const control = new L.Control.MyControl()
    control.addTo(map);

    const controlDivs = document.getElementsByClassName(className)

    if (['leaflet-control-bottom-right', 'leaflet-control-bottom-left', 'leaflet-control-bottom-center'].includes(className)) {
        for (let i = controlDivs.length - 1; i > 0; --i) {
            controlDivs[i].remove();
        }
    } else if (['leaflet-control-top-left', 'leaflet-control-top-right'].includes(className)) {
        for (let i = 0; i < controlDivs.length - 1; ++i) {
            controlDivs[i].remove();
        }
    }

    return createPortal(children, controlDiv);
}
